function AlertWsp() {
  return (
    <div className="absolute bottom-20 right-0 bg-white shadow-lg p-3 rounded-lg w-64 z-[9999] text-gothamB text-gray-800">
      ¿Necesitás ayuda para registrarte?{" "}
      <a
        href="https://wa.me/5491123053139"
        target="_blank"
        rel="noopener noreferrer"
        className="text-green-600 font-semibold hover:underline"
      >
        Contactanos
      </a>
    </div>
  );
}

export default AlertWsp;
